<rms-carousel [list]="yearsListSet"
              [initialSelectedValue]="initialValue"
              (yearSelected)="onYearSelected($event)">
</rms-carousel>
<ul class="rounded-items-list mt-4">
  <li *ngFor="let item of quarterList" (click)="selectQuarter(item)" [class.active]="item.selected">{{item.name}}</li>
</ul>
